import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";
import BackButton from "../../components/BackButton";

import Lesny from "../../content/przyjaznedeklaracje/podatek-lesny/section-1_pl.mdx";

export default function PodatekLesny(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "lesny";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx maxWidth>
				<Lesny />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox center>
					<DeclarationBoxItem miasto={Miasto} podatek={Podatek} noReadMore />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} podatek={Podatek} />
			</Section>

			<Section>
				<BackButton />
			</Section>
		</SectionLayout>
	);
}
